// extracted by mini-css-extract-plugin
export default {"container":"tO","promoapplied":"uO","tobeapplied":"vO","hr":"wO","teal":"xO","promoappliedcontainer":"yO","error":"zO","input":"AO","errorInput":"BO","promo_x":"CO","promo_info":"EO","promoxcontainer":"FO"};
    if(module.hot) {
      // 1715188237901
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  